import React, { useState, useEffect } from "react";
import axios from "axios";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/system";
import Loader from "../Loader/Loader";
import Coursedetail from "../../components/CourseDetailComponent/Coursedetail";
import { useParams } from "react-router-dom";
// import axios from axios;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#F2F2F2",
  ...theme.typography.body2,
  //   padding: `calc(1em + ${theme.spacing(1)})`,
  padding: theme.spacing("70px 0 0 250px"),
  borderRadius: 0,
  boxShadow: "none !important",
  fontSize: 20,
  fontWeight: "bold",
  color: "#004A99",
  height: "100%",
}));

const CourseDetail = () => {
  const [coursedetail, setCoursedetail] = useState([]);
  //   const [apicall,setapicall] = useState("");
  const [render, setRender] = useState(false);
  const [pending, setPending] = useState(true);
  const { id } = useParams();
  //   const params = useParams();

//   const fetchData = async () => {
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_DOMAIN}api/v1/a34jl49u-q4r67p89/courses/${id}/chapter`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             "Accept": "application/json",
//             "withCredentials": true,
//             // Authorization: token,
//           },
//         }
//       );
//       setCoursedetail(res.courses);
//       //   setCourse(res.data.course);
//       console.log(res.data.course);
//     } catch (error) {
//       console.log("error => ", error);
//     }
//   };

//   useEffect(() => {
//     fetchData(id);
//   }, [id]);

    const getCourseDetail = async () => {
      // console.log("api url kths", `api/v1/a34jl49u-q4r67p89/courses/${id}/chapter`);
      // setapicall("api url kths", `api/v1/a34jl49u-q4r67p89/courses/${id}/chapter`);
      // console.log(apicall);
      const api = `/api/v1/a34jl49u-q4r67p89/courses/${id}/chapter`;
      console.log(api);
      const request = {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          withCredentials: true,
          // Authorization: token,
        },
      };
      // setPending(true);
      fetch(api, request)
        .then((response) => response.json())
        .then((res) => {
          console.log("user api res", res.chapter);
          setCoursedetail(res.chapter);
          setPending(false);
        })
        .catch((err) => console.log("err", err));
    };

    useEffect(() => {
      getCourseDetail();
    }, [render]);
  return (
    <>
      <Item>
        <Box sx={{ padding: "18px" }}>
          {!pending ? (
            <Coursedetail
              setRender={setRender}
              render={render}
              coursedetail={coursedetail}
            />
          ) : (
            <Loader />
          )}
        </Box>
        {/* <Typography>User Lists</Typography> */}
      </Item>
    </>
  );
};

export default CourseDetail;
